import {DEFAULT_ACTIVE_LOCATION_STATE, type Location} from '../../../../store/state/locations/state'
import useLocationActions from '../../../../store/state/locations/use-actions'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {activeLocationSelector} from '../../../../store/state/locations/selectors'
import {DropdownItemStyle} from './_styles/location-dropdown.styled'
import {useDimensions} from '../../../../contexts/dimensions/use-dimensions'
import * as RadioStyled from '../shared/radio-button.styled'
import {useDispatch} from 'react-redux'
import {logEventFor} from '../../../../store/state/audit-log/action-creators'

import type {JSX} from 'react'

interface DropDownItemProps {
    location: Location
}
export function DropDownItem({location}: DropDownItemProps): JSX.Element {
    const {setActiveLocation} = useLocationActions()
    const activeLocation = useTypedSelector(activeLocationSelector)
    const {width} = useDimensions()
    const dispatch = useDispatch()
    const onClickWrapper = (location: Location) => {
        setActiveLocation(location)
        const formattedInfo =
            location.description === DEFAULT_ACTIVE_LOCATION_STATE.description
                ? 'FLEET_VIEW'
                : 'INDIVIDUAL_VESSEL'
        dispatch(logEventFor('selectActiveLocation', 'Menu', formattedInfo))
    }

    return (
        <DropdownItemStyle
            width={width}
            onClick={() => {
                onClickWrapper(location)
            }}
        >
            <RadioStyled.Container>
                <RadioStyled.Input
                    type="radio"
                    id={`${location.location}-radio`}
                    value={location.location}
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    checked={activeLocation && activeLocation.location === location.location}
                    onChange={() => setActiveLocation(location)}
                    disabled={false}
                />
                <RadioStyled.Label htmlFor={`${location.location}-radio`}>
                    {/* TODO: Fix this the next time the file is edited. */}
                    {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
                    {location?.description || 'Unknown'}
                </RadioStyled.Label>
            </RadioStyled.Container>
        </DropdownItemStyle>
    )
}
